import React from "react";
import { createRoot } from "react-dom/client";
import HeaderApp from "../components/shared/layouts/header/HeaderApp";

// ======== AppHeader（全ページ共通ヘッダー） ========
const headerEl = document.getElementById("app-header");

if (headerEl) {
  const currentUser = headerEl.dataset.currentUser
    ? JSON.parse(headerEl.dataset.currentUser)
    : null;

  const currentCompanyUser = headerEl.dataset.currentCompanyUser
    ? JSON.parse(headerEl.dataset.currentCompanyUser)
    : null;

  const isCompany = !!currentCompanyUser;

  // company の種別（management / recruit）
  const companyRole = headerEl.dataset.companyRole;

  // ログアウト処理
  const onClickLogout = async () => {
    const csrfToken = document
      .querySelector('meta[name="csrf-token"]')
      ?.getAttribute("content");

    const logoutPath = isCompany
      ? "/company_users/sign_out"
      : "/users/sign_out";
    const redirectPath = isCompany
      ? "/company_users/sign_in"
      : "/users/sign_in";

    try {
      const response = await fetch(logoutPath, {
        method: "DELETE",
        credentials: "same-origin",
        headers: { "X-CSRF-Token": csrfToken, Accept: "text/html" },
      });

      if (response.ok) {
        window.location.href = redirectPath;
      } else {
        window.location.reload();
      }
    } catch (e) {
      window.location.reload();
    }
  };

  // unread は Railsの #react-unread から拾う
  const unreadEl = document.getElementById("react-unread");
  const unread = unreadEl
    ? {
        projectIndexUrl: unreadEl.dataset.projectIndexUrl,
        jobIndexUrl: unreadEl.dataset.jobIndexUrl,
        unreadProjects: JSON.parse(unreadEl.dataset.projects || "[]"),
        unreadJobs: JSON.parse(unreadEl.dataset.jobs || "[]"),
        projectUnreadCount: Number(unreadEl.dataset.projectUnreadCount || 0),
        jobUnreadCount: Number(unreadEl.dataset.jobUnreadCount || 0),
      }
    : null;

  if (!headerEl.__reactRoot) headerEl.__reactRoot = createRoot(headerEl);
  headerEl.__reactRoot.render(
    <HeaderApp
      currentUser={currentUser}
      currentCompanyUser={currentCompanyUser}
      companyRole={companyRole}
      unreadInitial={unread}
      onClickLogout={onClickLogout}
    />,
  );
}
